import React, { Component } from 'react';
import { Row, Col, Button } from 'reactstrap';
import FacebookLogin from 'react-facebook-login';
import { GoogleLogin } from 'react-google-login';
import { connect } from 'react-redux';
import { FaFacebook, FaGoogle } from 'react-icons/fa';
import { authenticateWithFacebook, authenticateWithGoogle } from '../../redux/actions/user.actionCreator';

const mapDispatchToProps = dispatch => ({
    authenticateWithFacebook: (name, email, token) => dispatch(authenticateWithFacebook(name, email, token)),
    authenticateWithGoogle:   (name, email, token) => dispatch(authenticateWithGoogle(name, email, token)),
});

const mapStateToProps = state => ({
    TokenDeviseRegister: state.user.TokenDeviseRegister,
});

class SocialLogin extends Component {

    facebookLoginClicked = () => { /* Native WebView click */ };
    googleLoginClicked   = () => { /* Native WebView click */ };

    responseFacebook = (response) => {
        if (response.email) {
            this.props.authenticateWithFacebook(response.name, response.email, this.props.TokenDeviseRegister);
        } else if (response.id) {
            this.props.authenticateWithFacebook(response.name, response.id, this.props.TokenDeviseRegister);
        }
    };

    responseGoogle = (response) => {
        if (response.profileObj) {
            this.props.authenticateWithGoogle(response.profileObj.name, response.profileObj.email, this.props.TokenDeviseRegister);
        }
    };

    handleNativeMessage = (e) => {
        if (!e.data || typeof e.data !== 'string') return;
        let event;
        try { event = JSON.parse(e.data); } catch (_) { return; }

        if (event.type === 'facebookLoginNative') {
            if (event.data.email) this.props.authenticateWithFacebook(event.data.name, event.data.email, this.props.TokenDeviseRegister);
            else                   this.props.authenticateWithFacebook(event.data.name, event.data.id,    this.props.TokenDeviseRegister);
        }
        if (event.type === 'googleLoginNative') {
            if (event.data.email) this.props.authenticateWithGoogle(event.data.name, event.data.email, this.props.TokenDeviseRegister);
            else                   this.props.authenticateWithGoogle(event.data.name, event.data.id,    this.props.TokenDeviseRegister);
        }
        if (event.type === 'appleLoginNative') {
            if (event.data.fullName && event.data.email) {
                const fullName = `${event.data.fullName.givenName} ${event.data.fullName.familyName}`;
                this.props.authenticateWithGoogle(fullName, event.data.user, this.props.TokenDeviseRegister);
            } else {
                this.props.authenticateWithGoogle('', event.data.user, this.props.TokenDeviseRegister);
            }
        }
    };

    componentDidMount() {
        document.addEventListener('message', this.handleNativeMessage);
        window.addEventListener('message', this.handleNativeMessage);
    }

    componentWillUnmount() {
        document.removeEventListener('message', this.handleNativeMessage);
        window.removeEventListener('message', this.handleNativeMessage);
    }

    render() {
        const btnStyle = {
            borderRadius: 12,
            padding: '12px 20px',
            fontWeight: 700,
            fontSize: '0.9rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            border: 'none',
            cursor: 'pointer',
            width: '100%',
            transition: 'all 0.2s',
        };

        /* Native mobile view */
        if (window.ReactNativeWebView !== undefined) {
            return (
                <Row className="text-center">
                    <Col>
                        <button onClick={this.facebookLoginClicked}>
                            <FaFacebook size={16} /> Continuer avec Facebook
                        </button>
                        <button onClick={this.googleLoginClicked}>
                            <FaGoogle size={16} /> Continuer avec Google
                        </button>
                    </Col>
                </Row>
            );
        }

        /* Web view */
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <FacebookLogin
                    appId="3510498158961039"
                    autoLoad={false}
                    fields="name,email"
                    callback={this.responseFacebook}
                    textButton="  Connexion avec facebook"
                    cssClass="FacebookClass"
                    icon="fa-facebook-square fa-lg"
                    language="fr_FR"
                    redirectUri="https://eudeliv.com/login"
                />

                <GoogleLogin
                    clientId="816345816661-t0l1hi5g12rkasa14h9ja1sbij1faats.apps.googleusercontent.com"
                    onSuccess={this.responseGoogle}
                    render={renderProps => (
                        <button onClick={renderProps.onClick}
                            className="GoogleClass">
                            <FaGoogle size={18} color="#white" /> Continuer avec Google
                        </button>
                    )}
                />
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SocialLogin);
